import React from "react";
import RecommendDesign from "../../components/recommendations/recommended-design/RecommendDesign";

const RecommendedDesignPage = () => {
	return (
		<>
			<RecommendDesign />
		</>
	);
};

export default RecommendedDesignPage;
